import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardLineItem,
  CardTitle,
  Text,
} from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { serverErrorFallbackText } from "@/lib/data/static/fallbackMessages";
import {
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
} from "@/lib/data/static/permissionOptions";
import { ErrorBoundary } from "@sentry/react";
import { startCase } from "lodash";
import { Edit } from "lucide-react";
import { useState } from "react";
import { EditFirmSettingsModal } from "./EditFirmSettingsModal";

function FirmDetailsViewDangerous() {
  const { currentUser, hasActionPermission } = useUser();
  const firm = currentUser.firm;

  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Card className="w-full md:w-3/4 lg:w-1/2">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium"></CardTitle>
          {hasActionPermission(
            ACTION_PERMISSION_KEYS.firm,
            ACTION_PERMISSION_VALUES.update,
          ) && (
            <Button
              onClick={() => {
                setIsOpen(true);
              }}
              variant="outline"
              size="sm"
            >
              <Edit className="h-4 w-4" />
              <Text
                as="span"
                variant="body"
                className="hidden md:ml-2 md:block"
              >
                Edit
              </Text>
            </Button>
          )}
        </CardHeader>
        <CardContent className="pt-2">
          <dl className="divide-primary-foreground divide-y">
            <CardLineItem
              isLoading={false}
              label="Firm name"
              value={firm.name}
            />
            <CardLineItem
              isLoading={false}
              label="Description"
              value={firm.description ?? undefined}
            />
            <CardLineItem
              isLoading={false}
              label="Color"
              value={startCase(firm.colorTheme ?? undefined)}
            />
          </dl>
        </CardContent>
      </Card>
      <EditFirmSettingsModal open={isOpen} setOpen={setIsOpen} firm={firm} />
    </>
  );
}

export default function FirmDetailsView() {
  return (
    <ErrorBoundary
      fallback={<Text variant="subHeading">{serverErrorFallbackText}</Text>}
    >
      <FirmDetailsViewDangerous />
    </ErrorBoundary>
  );
}
